import { BaseServices, HttpMethod } from './base'
import { BridgeService } from './bridge'

export interface IGenerateIdUnicoLinkRequest {
  encryptData: string
  seed: string
}

export interface IResponseGenerateIdUnicoLink {
  encryptData: string
  seed: string
}

export default async (data: IGenerateIdUnicoLinkRequest, accessToken?: string) => {
  const pathname = process.env.REACT_APP_GENERATE_ID_UNICO_LINK
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST

  const headers: Record<string, string> = {}
  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const response = await BaseServices.request<IResponseGenerateIdUnicoLink>({
    headers,
    pathname,
    method,
    host,
    data,
  })

  return response
}
